// extracted by mini-css-extract-plugin
export var actions = "_s2-4";
export var item = "_s2-1";
export var price = "_s2-3";
export var quantity = "_s2-2";
export var table = "_s2-0";